






















































import { Vue, Component } from 'vue-property-decorator';
import TextInput from '@/components/TextInput.vue';
import { PickerInput } from '@/components';
import SyEditor from '@/components/SyEditor.vue';
import { Field, Toast } from 'vant';
import Uploader from '@/components/Uploader.vue';
import { save, ifSave } from '../api';
import { isWeiXin } from '@/common/ts/common';
Vue.use(Field).use(Toast);
@Component({
  components: {
    TextInput,
    PickerInput,
    SyEditor,
    Uploader,
  },
})
export default class Apply extends Vue {
  color = '#c01a20';
  roleArr = [
    '鼠女',
    '金塔拉',
    '鼠女/塔拉妈妈',
    '乐团学长',
    '相亲男A',
    '相亲男B',
    '相亲男C',
    '侍女/闺蜜',
  ];
  name: string = '';
  age: string = '';
  sex: string = '';
  job: string = '';
  role: string = '';
  message: string = '';
  isSave = false;
  isLogin = false;
  created() {
    this.ifSaved();
    window.userInfoChange = () => {
      this.$router.go(0);
    };
  }
  async ifSaved() {
    const res: any = await ifSave();
    if (res.code === 203) {
      this.isLogin = false;
      window.handleMessage('{"action":"mUserLogin","data":""}');
    }
    if (res.code === 500) {
      this.isLogin = true;
    }
    if (res.code === 200) {
      this.isSave = true;
      this.isLogin = true;
    }
  }
  async handleSubmit() {
    if (isWeiXin()) {
      Toast('请在上游APP参加活动！');
    }
    if (window.gettoken && !window.gettoken()) {
      if (parseFloat(window.version) >= 4.5) {
        window.handleMessage('{"action":"mUserLogin","data":""}');
      } else {
        window.location.href = 'client:logout';
      }
    }
    if (!this.testSubmitData()) {
      return;
    }

    const UPLOAD_CMP = this.$refs.Uploader as Uploader;
    if (UPLOAD_CMP.displayImages.length < 2) {
      return Toast('图片不能少于两张！');
    }
    const img: any = await UPLOAD_CMP.uploadToOss();
    if (img.length >= 2) {
      const data = {
        name: this.name,
        sex: this.sex,
        year: this.age,
        job: this.job,
        recommend: this.role,
        declaration: this.message,
        cover: '|' + img.join('|'),
      };
      const res: any = await save(data);
      if (res.code === 200) {
        Toast.success('报名成功谢谢您的参与');
        setTimeout(() => {
          this.$router.go(0);
        }, 800);
      } else {
        Toast(res.msg);
      }
    }
  }
  testSubmitData(): boolean {
    if (this.name === '') {
      Toast('请输入您的姓名');
      return false;
    }
    if (this.sex === '') {
      Toast('请选择您的性别');
      return false;
    }
    if (this.age === '') {
      Toast('请输入您的年龄');
      return false;
    }
    if (this.job === '') {
      Toast('请输入您的职业');
      return false;
    }
    if (this.role === '') {
      Toast('请选择自荐角色');
      return false;
    }
    if (this.message === '') {
      Toast('请输入自荐宣言');
      return false;
    }
    return true;
  }

  _handleSex(e: string, index: number) {
    this.sex = e;
  }
  _handleRole(e: string, index: number) {
    this.role = e;
  }
}
